import { SupernovaPagedBody } from '../../foundation'
import { asBuilder } from '../asBuilder'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSupernovaPagedBody = asBuilder((): SupernovaPagedBody<any[]> => {
  return {
    totalPageNumber: 999,
    currentPageIndex: 0,
    pageSize: 10,
    isLastPage: false,
    totalElementNumber: 9990,
    contents: [],
  }
})
